module.exports = __webpack_public_path__ + "static/media/blog-36-img4.b70b6b74.webp";